import React, { memo, useRef, useEffect, useState } from 'react';
import SlackIntegration from '../components/Slack/SlackIntegration';
import MsTeamIntegration from '../components/MSTeams/MsTeamIntegration';
import { useSelector } from 'react-redux';
import { selectAuthIsTeamOwner } from '../redux/selectors/authSelectors';

let cachedIsTeamOwner = null;
let hasInitialized = false;

const ConfigPage = memo(() => {
  const isTeamOwner = useSelector(selectAuthIsTeamOwner);
  const [cachedTeamOwner, setCachedTeamOwner] = useState(() => {
    if (isTeamOwner !== undefined) {
      cachedIsTeamOwner = isTeamOwner;
      hasInitialized = true;
      return isTeamOwner;
    }
    return cachedIsTeamOwner;
  });

  const isMountedRef = useRef(true);

  useEffect(() => {
    if (
      !hasInitialized ||
      (cachedIsTeamOwner !== isTeamOwner && cachedIsTeamOwner !== true)
    ) {
      cachedIsTeamOwner = isTeamOwner;
      hasInitialized = true;
      if (isMountedRef.current) {
        setCachedTeamOwner(isTeamOwner);
      }
    }

    return () => {
      isMountedRef.current = false;
    };
  }, [isTeamOwner]);

  if (!cachedTeamOwner) {
    return <div>Access denied. Team owner privileges required.</div>;
  }

  return (
    <div>
        <SlackIntegration />
        <MsTeamIntegration />
    </div>
  );
});

ConfigPage.displayName = 'ConfigPage';

export default ConfigPage;